export enum PaymentMethodType {
  BankAccount = 'BankAccount',
}
